module Meevo.Components.Controls {
    declare let d3: any;
    
    import IDashboardGoalsGraphsLogic = Meevo.Plugins.DashboardGoals.IDashboardGoalsGraphsLogic;
    import GoalDateRangeEnum = Meevo.Components.Goals.GoalDateRangeEnum;
    import IDashboardGoalModel = Meevo.Plugins.DashboardGoals.IDashboardGoalModel;
    import GoalInputTypeEnum = Meevo.Components.Goals.GoalInputTypeEnum;

    class MeevoGoalsGroupedBarChartComponent implements angular.IComponentController {
        
        static $inject = ['$scope', '$translate', '$locale', 'meevo.plugins.docsAndForms.DashboardGoalsGraphsLogic'];
        public goalDecimal: number;
        public actualDecimal: number;
        public chartClass: string;
        public parent: any;
        public goal: number;
        public actual: number;
        private dashboardGoalsGraphsLogic: IDashboardGoalsGraphsLogic;
        public productivityDateRange: GoalDateRangeEnum = GoalDateRangeEnum.YearToDate;
        public productivityGoalsData: any[];
        public currentGoalsModel: IDashboardGoalModel;

        constructor(private $scope: ng.IScope, private $translate: ng.translate.ITranslateService,
            private $locale: angular.ILocaleService) {
        }

        $onInit = () => {

            this.$scope.$watch(() => this.productivityGoalsData, (value) => {
                if (!value) return;
            });

            let chartClass: string = '.'.concat(this.chartClass);
        }

    }


    angular.module('meevo.components.controls')
        .component('meevoGoalsGroupedBarChartComponent', <angular.IComponentOptions>{
            templateUrl: 'app/components/controls/charts/goalsGroupedBarChart/goalsGroupedBarChart.template.html',
            controller: MeevoGoalsGroupedBarChartComponent,
            controllerAs: 'vm3',
            bindings: {
                chartClass: '@',
                goal: '<',
                actual: '<',
                mapFn: '=',
                currentGoalsModel: '&',
                productivityData: '=?'
            },
            require: {
                parent: '^^meevoGoalsTileComponent'
            }
        });
}